import React, { useEffect, useRef, useState } from 'react';

export const LazyVimeo = ({
  videoId,
  bgImage,
  width = '640',
  height = '360',
  autoplay = true,
  controls = 1,
  muted = true,
  loop = 1,
}) => {
  const containerRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsLoaded(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="vimeo-container">
      {isLoaded ? (
        <iframe
          src={`https://player.vimeo.com/video/${videoId}?autoplay=${
            autoplay ? 1 : 0
          }&muted=${muted}&loop=${loop}&playlist=${videoId}&controls=${controls}&title=0&byline=0&portrait=0&badge=0&autopause=0&transparent=1`}
          width={width}
          height={height}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <a href={`https://vimeo.com/${videoId}`} target="_blank" rel="noopener noreferrer">
          <img
            src={bgImage || `https://vumbnail.com/${videoId}.jpg`} // Превью-картинка видео
            alt="Vimeo Preview"
            className="vimeo-thumbnail"
          />
        </a>
      )}
    </div>
  );
};
